import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTetrisly = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 4.35v-2.2c0-.14 0-.21.027-.263a.25.25 0 0 1 .11-.11c.053-.027.123-.027.263-.027h2.2c.14 0 .21 0 .264.027a.25.25 0 0 1 .109.11c.027.053.027.123.027.263v2.2c0 .14 0 .21-.027.264a.25.25 0 0 1-.11.109c-.053.027-.123.027-.263.027h-2.2c-.14 0-.21 0-.263-.027a.25.25 0 0 1-.11-.11C1.75 4.56 1.75 4.49 1.75 4.35Zm6.75 13.5v-2.2c0-.14 0-.21.027-.264a.25.25 0 0 1 .11-.109c.053-.027.123-.027.263-.027h2.2c.14 0 .21 0 .264.027a.251.251 0 0 1 .109.11c.027.053.027.123.027.263v2.2c0 .14 0 .21-.027.263a.251.251 0 0 1-.11.11c-.053.027-.123.027-.263.027H8.9c-.14 0-.21 0-.264-.027a.25.25 0 0 1-.109-.11C8.5 18.06 8.5 17.99 8.5 17.85Zm9.75-15.7v2.2c0 .14 0 .21-.027.264a.25.25 0 0 1-.11.109c-.053.027-.123.027-.263.027H11.9c-.14 0-.21 0-.264.027a.25.25 0 0 0-.109.11c-.027.053-.027.123-.027.263v5.95c0 .14 0 .21-.027.264a.251.251 0 0 1-.11.109c-.053.027-.123.027-.263.027H8.9c-.14 0-.21 0-.264-.027a.25.25 0 0 1-.109-.11C8.5 11.31 8.5 11.24 8.5 11.1V2.15c0-.14 0-.21.027-.263a.25.25 0 0 1 .11-.11c.053-.027.123-.027.263-.027h8.95c.14 0 .21 0 .263.027a.25.25 0 0 1 .11.11c.027.053.027.123.027.263Z"
	})]
});
const ForwardRef = forwardRef(SvgTetrisly);
export { ForwardRef as ReactComponent };
